Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDefaultProvider = void 0;
var NotificationDefaultProvider = (function () {
    function NotificationDefaultProvider() {
    }
    NotificationDefaultProvider.prototype.getNotificationTitle = function (notification) {
        return '';
    };
    NotificationDefaultProvider.prototype.getNotificationContent = function (notification) {
        return '';
    };
    NotificationDefaultProvider.prototype.getMaxShownContentLineCount = function () {
        return undefined;
    };
    NotificationDefaultProvider.prototype.getErrorMessage = function (notification) {
        return '';
    };
    return NotificationDefaultProvider;
}());
exports.NotificationDefaultProvider = NotificationDefaultProvider;
//# sourceMappingURL=NotificationDefaultProvider.js.map